import useHostingInfo from '~/hooks/useHostingInfo';

const useSubBrand = (): string => {
  const { hostingAccount } = useHostingInfo();
  const subBrand = hostingAccount?.data?.billing?.subbrand;
  return typeof subBrand === 'string' ? subBrand : '';
};

export default useSubBrand;
